<template>
  <div class="ng-date-fields">
    <ui-form-select v-model="modelValue.month" :options="monthOptions" />
    <ui-form-input v-model="modelValue.day" placeholder="DD" />
    <ui-form-input v-if="showYear" v-model="modelValue.year" placeholder="YYYY" />
  </div>
</template>

<script>
import { prefixedShortMonths } from '../../../common/helper/months'

export default {
  name: 'UiFormDate',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  inject: {
    ngForm: {
      default: '',
    },
  },

  props: {
    monthOptions: {
      type: Array,
      required: false,
      default() {
        return prefixedShortMonths
      },
    },

    modelValue: {
      type: Object,
      required: true,
      default() {
        return {
          month: null,
          day: null,
          year: null,
        }
      },
    },

    showYear: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
